// extracted by css-extract-rspack-plugin
export default {"infiniteTable":"EditableEntityTable_infiniteTable__zEpxm","headerRow":"EditableEntityTable_headerRow__MRRxw","tableRow":"EditableEntityTable_tableRow__50JIX"};